import React, { Component, useReducer, } from 'react';

import './css/incrementer.css';

class ClassIncrementer extends Component {
    constructor(){
        super();
        this.state={
            count:1,
        }
        
        this.increment = this.increment.bind(this);
        this.decrement =this.decrement.bind(this);
        this.handleChange=this.handleChange.bind(this);

    }
    handleChange(e){
        e=parseInt(e);
        
        if (isNaN(e)){
            e=1;
        }
        if (e<1){
            e=1;
        }
        else if(e>1000)
            e=1000;
        

        this.setState({count:parseInt(e)});
    }
    increment(){
        if(this.state.count<1000){
            this.setState({
                count:this.state.count+1
            });
        }
            
    }
    
    decrement(){
        if(this.state.count > 1){
            this.setState({
                count:this.state.count-1
            });
        }
     }

    render() {
        return (
            <>
                <h2 className='incrementer-title'>Incrementer using class component</h2>
                <div className="incrementer-container">
                <button className="decrement same" onClick={this.decrement}>-</button>                        
                                                                                                                
                <input className="same input" type="number" max="1000" min="1" steps="1" value={this.state.count} onChange={(event)=>{this.handleChange(event.target.value)}}/>
                <button className="increment same" onClick={this.increment}>+</button>  
                
                </div>
            </>
            
        )
    }
}
function UseReducerIncrementer(){
    // reducer function can be anywhere in the project
    // reducer function takes two arguments state and action
    // action is object which has a type
    // reducer function always returns somethings
    const reducer=(state,action)=>{
        if (action.type === 'INCREMENT'){
            if (state <= 1000)
                return state+1;
        }
        else if (action.type === "DECREMENT"){
             if (state>1)
                return state -1;
        }
        return state;
    }
    const [state, dispatch] = useReducer(reducer, 1 );
    return (
        <>
            <h2 className='incrementer-title'>Incrementer using use Reduce hook</h2>
            <div className="incrementer-container">
                <button className="decrement same" onClick={()=>dispatch({type:"DECREMENT"})}>-</button>                        
                                                                                                                
                <input className="same input" type="number" max="1000" min="1" steps="1" value={state} readOnly={true}/>
                <button className="increment same" onClick={()=>dispatch({type:"INCREMENT"})}>+</button>  
            </div>
        </>
    );

}


const Incrementer = () => {
  return (
    <div>
        
        <ClassIncrementer />
        <span className="breakline"></span>
        <UseReducerIncrementer />
        <p className="incrementer-constraints">
            <strong className="important">Note:</strong> Here, the Count cannot go <strong className="important">below
            1 and above 999</strong>. The use-Reducer count is read-only while the Class-component
            count is editable.
        </p>
    </div>
  )
}

export default Incrementer
